export default __webpack_public_path__ + "static/blob-51-540da37a78b4cb79e4204142562faecb.svg";